import { render, staticRenderFns } from "./AvatarMenuListContent.vue?vue&type=template&id=2ea7e042"
import script from "./AvatarMenuListContent.vue?vue&type=script&lang=ts"
export * from "./AvatarMenuListContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports